// removed by extract-text-webpack-plugin
module.exports = {"name":"_1mdLJaq2vy"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/presentational/ContactInfo/ContactInfo.module.less
// module id = 998
// module chunks = 3